import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { SubPanel } from "../SubPanel/SubPanel.js";
import { cardVariants } from "./Card.variants.js";
function Card({ as = 'button', size, children, className, topSubPanel, topSubPanelEmphasis, bottomSubPanel, bottomSubPanelEmphasis, cardClassName, onClick, slots = {} }) {
    const { cardSlot, contentSlot, cardContainerSlot, topSubPanelContainerSlot, topSubPanelSlot } = cardVariants({
        as,
        size
    });
    return /*#__PURE__*/ jsxs("div", {
        className: cn(cardContainerSlot(), className),
        children: [
            topSubPanel && /*#__PURE__*/ jsx(SubPanel, {
                position: "top",
                emphasis: topSubPanelEmphasis,
                slots: {
                    containerSlot: cn(topSubPanelContainerSlot(), slots.topSubPanelContainerSlot),
                    subPanelSlot: cn(topSubPanelSlot(), slots.topSubPanelSlot)
                },
                children: topSubPanel
            }),
            'div' === as ? /*#__PURE__*/ jsx("div", {
                className: cn(cardSlot(), cardClassName),
                ...onClick && {
                    role: 'button',
                    tabIndex: 0,
                    onKeyDown: (evt)=>{
                        if ('Enter' === evt.key || ' ' === evt.key) {
                            evt.preventDefault();
                            evt.stopPropagation();
                            onClick?.();
                        }
                    },
                    onClick
                },
                children: /*#__PURE__*/ jsx("div", {
                    className: contentSlot(),
                    children: children
                })
            }) : /*#__PURE__*/ jsx("button", {
                className: cn(cardSlot(), cardClassName),
                onClick: onClick,
                children: /*#__PURE__*/ jsx("div", {
                    className: contentSlot(),
                    children: children
                })
            }),
            bottomSubPanel && /*#__PURE__*/ jsx(SubPanel, {
                position: "bottom",
                emphasis: bottomSubPanelEmphasis,
                children: bottomSubPanel
            })
        ]
    });
}
export { Card };
